import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import "./index.scss";
import { useWindowSize } from "../../../../hooks/use-device-type";

export interface SvgCompUseProps {}

export function SvgCompUse(props: SvgCompUseProps) {
  const { isMobile } = useWindowSize();
  const placement = isMobile ? "top" : "left-start";

  return (
    <OverlayTrigger
      placement={placement}
      // show={true}
      overlay={
        <Popover id="svg-comp-use">
          <Popover.Body>
            <h3>核心：提升和转化</h3>

            <ul>
              <li>提升人才价值；</li>
              <li>转化价值成果；</li>
              <li>构建高端人才大数据中心。</li>
            </ul>
          </Popover.Body>
        </Popover>
      }
    >
      <g className="svg-comp-piece">
        <path
          xmlns="http://www.w3.org/2000/svg"
          fill="#fec000"
          d="M -0.5,297.5 C -0.5,282.833 -0.5,268.167 -0.5,253.5C 3.50854,210.307 16.8419,170.141 39.5,133C 33.3333,127.5 27.1667,122 21,116.5C 20.3123,115.668 20.479,115.002 21.5,114.5C 56.221,121.911 90.8877,129.578 125.5,137.5C 134.51,170.2 143.844,202.866 153.5,235.5C 152.998,236.521 152.332,236.688 151.5,236C 148.631,232.796 145.465,229.963 142,227.5C 125.486,280.266 135.319,327.433 171.5,369C 149.331,368.617 127.164,367.783 105,366.5C 101.5,366.833 98,367.167 94.5,367.5C 80.8333,390.833 67.1667,414.167 53.5,437.5C 30.4793,407.784 14.646,374.451 6,337.5C 3.26785,324.111 1.10118,310.777 -0.5,297.5 Z"
        />

        <text x={40} y={290} fontSize={60} fill="#fff" fontWeight={"bold"}>
          用
        </text>
      </g>
    </OverlayTrigger>
  );
}
